export * from './consumer/types';
export * from './activeConsumer/types';
export * from './visitContext/types';
export * from './visit/types';
export * from './storage/types';
export * from './system/types';
export * from './appointments/types';
export * from './activity/types';
export * from './testMyDevice/types';

export const KEY = 'AMWELL';

export interface LoadableReducerStateValue<T> {
  data: Nullable<T>;
  loading: boolean;
  error: Nullable<Error>;
}
